import { createContext, useContext, useEffect, useState } from "react";
import { effectivePrice } from "@/lib/api";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("osp_cart")) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("osp_cart", JSON.stringify(items)); }, [items]);

  const addItem = (product, variant, qty = 1) => {
    setItems((prev) => {
      const key = `${product.id}:${variant.id}`;
      const found = prev.find((i) => `${i.product_id}:${i.variant_id}` === key);
      if (found) {
        return prev.map((i) =>
          `${i.product_id}:${i.variant_id}` === key ? { ...i, qty: i.qty + qty } : i
        );
      }
      return [...prev, {
        product_id: product.id, variant_id: variant.id, name: product.name,
        variant_label: variant.label, image: product.image,
        price: effectivePrice(product, variant), qty,
      }];
    });
    setOpen(true);
  };

  const updateQty = (product_id, variant_id, qty) => {
    setItems((prev) =>
      qty <= 0
        ? prev.filter((i) => !(i.product_id === product_id && i.variant_id === variant_id))
        : prev.map((i) => (i.product_id === product_id && i.variant_id === variant_id ? { ...i, qty } : i))
    );
  };

  const clear = () => setItems([]);
  const subtotal = items.reduce((s, i) => s + i.price * i.qty, 0);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, addItem, updateQty, clear, subtotal, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
